export enum PricingBreakdownLineType {
    Charge = 0,
    Deduction = 1,
    Total = 2,
    Separator = 3,
    Subtotal = 4,
    Text = 5,
    Header = 6,
}

export enum ReceiptScenario {
    Connex = 0,
    DefaultRide = 1,
    BoracayRide = 2,
    BoracayDayTrip = 3,
}

export interface PricingBreakdownLine {
    DisplayName: string;
    Amount: number;
    Text?: string;
    LineType: PricingBreakdownLineType;
    IsIndented?: boolean;
}

export interface PricingBreakdown {
    Role: number;
    Scenario: ReceiptScenario;
    Lines: PricingBreakdownLine[];
}
